/** Avisos da página de entrada: porque é que a pessoa está fora.
 *
 *  Os códigos de link vêm do backend no endereço (`/login?aviso=...`,
 *  ver backend/core/auth_regras.py); o de sessão terminada vem do
 *  próprio frontend, quando um pedido a meio do trabalho recebe 401.
 *  Puro e sem React, para se testar sem DOM.
 */

export interface AvisoDeEntrada {
  texto: string
  /** O remédio é pedir outro link: a página abre já nesse modo. */
  pedirNovoLink: boolean
}

export const SESSAO_TERMINADA = 'sessao-terminada'

export const AVISOS_DE_ENTRADA: Record<string, AvisoDeEntrada> = {
  'link-invalido': {
    texto:
      'O link de acesso não é válido. Peça um novo link de acesso abaixo.',
    pedirNovoLink: true,
  },
  'link-usado': {
    texto:
      'Este link de acesso já foi utilizado. Cada link serve uma única vez, ' +
      'e alguns serviços de email abrem-nos automaticamente para ' +
      'verificação. Peça um novo link de acesso abaixo.',
    pedirNovoLink: true,
  },
  'link-expirado': {
    texto:
      'O link de acesso expirou (é válido durante 15 minutos). Peça um ' +
      'novo link de acesso abaixo.',
    pedirNovoLink: true,
  },
  'sem-acesso': {
    texto:
      'O acesso a este workspace foi revogado. Se considera que se trata ' +
      'de um erro, contacte a VN2R.',
    pedirNovoLink: false,
  },
  'workspace-terminado': {
    texto:
      'O acesso a este workspace terminou: foi arquivado ou o período ' +
      'contratado chegou ao fim. Contacte a VN2R para o renovar.',
    pedirNovoLink: false,
  },
  'convite-invalido': {
    texto:
      'O link do convite não é válido. Se já entrou antes, peça um link de ' +
      'acesso abaixo com o seu email, deixando o workspace em branco.',
    pedirNovoLink: true,
  },
  'convite-usado': {
    texto:
      'Este convite já foi utilizado (cada convite serve uma única vez). Peça ' +
      'um link de acesso abaixo com o seu email, deixando o workspace em branco.',
    pedirNovoLink: true,
  },
  'convite-expirado': {
    texto:
      'O convite expirou (é válido durante 7 dias). Peça a quem partilhou ' +
      'que volte a partilhar consigo.',
    pedirNovoLink: false,
  },
  'convite-aceite': {
    texto:
      'O convite foi aceite e o que lhe partilharam ficou na sua conta. Entre ' +
      'no seu workspace e abra Partilhados comigo.',
    pedirNovoLink: false,
  },
  [SESSAO_TERMINADA]: {
    texto:
      'A sessão terminou: foi aberta noutro dispositivo, expirou ou o ' +
      'acesso foi revogado. Inicie sessão novamente.',
    pedirNovoLink: false,
  },
}

/** O aviso pedido no endereço, se for um dos conhecidos. */
export function avisoDoEndereco(search: string): string | null {
  try {
    const v = new URLSearchParams(search).get('aviso')
    return v && v in AVISOS_DE_ENTRADA ? v : null
  } catch {
    return null
  }
}
